/**
 * Photo slot rules (Task 3).
 * Clothing: Front (required), Back, Tag (optional).
 * Shoes:    Front (required), Side, Sole (optional) - tip: stuff and lace them so they hold shape.
 */
export const SHOE_TIP = "Stuff and lace them so they hold shape.";

export const CLOTHING_SLOTS = [
  { key: "front", label: "Front", required: true, hint: "Lay it flat, whole garment in frame - sleeves too" },
  { key: "back", label: "Back", required: false, hint: "Flip it over" },
  { key: "tag", label: "Tag / Label", required: false, hint: "Brand + size tag, close and sharp" },
  { key: "detail", label: "Detail", required: false, hint: "Small logo, embroidery or a mark worth preserving", extra: true },
];

export const SHOE_SLOTS = [
  { key: "front", label: "Front", required: true, hint: `Toe facing you, pair together. ${SHOE_TIP}` },
  { key: "side", label: "Side", required: false, hint: "Outer side profile, heel to toe" },
  { key: "sole", label: "Sole", required: false, hint: "Flip them - shows the wear" },
];

export const isShoes = (item) => (item?.category || "") === "shoes";

/** Optional slots that still need a photo. `extra` slots (Detail) never count against completeness. */
export const missingPhotoSlots = (item) => {
  if (!item) return [];
  const slots = isShoes(item) ? SHOE_SLOTS : CLOTHING_SLOTS;
  return slots.filter((s) => !s.required && !s.extra && !item[`has_${s.key}`]);
};

export const photosIncomplete = (item) => !item?.review?.needs_front_photo && missingPhotoSlots(item).length > 0;
